module.exports = __webpack_public_path__ + "img/level_TH.67857c0a.png";